import { useEffect, useState, useTransition } from 'react';
import { Router as RouterPrimitive, RouterProps as RouterPropsPrimitive } from 'react-router-dom';
import { useGlobalTransition } from 'components/router/useGlobalTransition';

interface RouterProps extends RouterPropsPrimitive {}

const Router = ({ children, history }: RouterProps) => {
    const [isPending, startTransition] = useTransition();
    const setIsPending = useGlobalTransition(state => state.setIsPending);

    const [suspenseHistory] = useState(() => {
        const { push, replace, go } = history;

        history.push = (...args) => {
            startTransition(() => {
                push.apply(history, args);
            });
        };
        history.replace = (...args) => {
            startTransition(() => {
                replace.apply(history, args);
            });
        };
        history.go = (...args) => {
            startTransition(() => {
                go.apply(history, args);
            });
        };

        return history;
    });

    useEffect(() => {
        setIsPending(isPending);
    }, [isPending, setIsPending]);

    return <RouterPrimitive history={suspenseHistory}>{children}</RouterPrimitive>;
};

export { Router };
